import { Controller } from 'react-hook-form';
import TextInput from '@/components/Unistyles/TextInput';

function EventEditInputLocation() {
  return (
    <Controller
      name="location"
      render={({ field }) => (
        <TextInput
          onChangeText={field.onChange}
          value={field.value}
          placeholder="Location, optional"
          autoCapitalize="words"
          enterKeyHint="done"
          testID="EventEditInputLocation"
        />
      )}
    />
  );
}
export default EventEditInputLocation;
